import React, { useEffect, useState } from 'react';
import ShootLogo from '../../images/blue-shoot-logo.png';
import {
  FacebookIcon,
  // InstagramIcon,
  LinkedinIcon,
  MinusIcon,
  PlusIcon,
  // TwitterIcon,
} from './Icons';

function Footer() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <footer className="container footer">
      <div className="row">
        <div className="col-12 col-md-5">
          <a className="d-flex mb-4" href="/">
            <img src={ShootLogo} alt="logo" className="logo" width="132" height="50" loading="lazy" />
          </a>
          <p className="info mb-4 footer-summary">
            Shoot is your ultimate tool for managing remote teams efficiently.
            Track time, monitor productivity, and ensure security with our comprehensive platform.
          </p>
          <div className="d-none d-sm-flex mb-4">
            <a
              href="https://www.linkedin.com/company/shoot-software"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex me-3"
            >
              <span className="d-none">Linkedin</span>
              <LinkedinIcon width="24" height="24" />
            </a>
            {/* <a href="/" target="_blank" rel="noopener noreferrer" className="d-flex me-3"> */}
            {/*  <span className="d-none">Twitter</span> */}
            {/*  <TwitterIcon width="24" height="24" /> */}
            {/* </a> */}
            <a
              href="https://www.facebook.com/trustshoot"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex me-3"
            >
              <span className="d-none">Facebook</span>
              <FacebookIcon width="24" height="24" />
            </a>
            {/* <a href="/" target="_blank" rel="noopener noreferrer" className="d-flex me-3"> */}
            {/*  <span className="d-none">Instagram</span> */}
            {/*  <InstagramIcon width="24" height="24" /> */}
            {/* </a> */}
          </div>
        </div>
        <div className="col-12 col-md-7">
          <div className="footer-menus d-flex justify-content-between flex-column flex-sm-row">
            <details open={!isMobile}>
              <summary className="mb-2 d-flex justify-content-between align-items-center">
                Company
                <PlusIcon className="icon icon-plus" width="20" height="20" />
                <MinusIcon className="icon icon-minus" width="20" height="20" />
              </summary>
              <ul className="nav mobile-nav flex-column">
                <li><a className="nav-link" href="#about">About us</a></li>
                <li><a className="nav-link" href="#contact">Contact us</a></li>
                <li><a className="nav-link" href="#careers">Careers</a></li>
                <li><a className="nav-link" href="#press">Press</a></li>
              </ul>
            </details>
            <details open={!isMobile}>
              <summary className="mb-2 d-flex justify-content-between align-items-center">
                Product
                <PlusIcon className="icon icon-plus" width="20" height="20" />
                <MinusIcon className="icon icon-minus" width="20" height="20" />
              </summary>
              <ul className="nav mobile-nav flex-column">
                <li><a className="nav-link" href="#features">Features</a></li>
                <li><a className="nav-link" href="/pricing">Pricing</a></li>
                <li><a className="nav-link" href="#news">News</a></li>
                <li><a className="nav-link" href="#help">Help desk</a></li>
                <li><a className="nav-link" href="#support">Support</a></li>
              </ul>
            </details>
            <details open={!isMobile}>
              <summary className="mb-2 d-flex justify-content-between align-items-center">
                Resources
                <PlusIcon className="icon icon-plus" width="20" height="20" />
                <MinusIcon className="icon icon-minus" width="20" height="20" />
              </summary>
              <ul className="nav mobile-nav flex-column">
                <li><a className="nav-link" href="#documentation">Documentation</a></li>
                <li><a className="nav-link" href="#tutorials">Tutorials</a></li>
                <li><a className="nav-link" href="#blog">Blog</a></li>
                <li><a className="nav-link" href="#community">Community</a></li>
              </ul>
            </details>
            <details open={!isMobile}>
              <summary className="mb-2 d-flex justify-content-between align-items-center">
                Legal
                <PlusIcon className="icon icon-plus" width="20" height="20" />
                <MinusIcon className="icon icon-minus" width="20" height="20" />
              </summary>
              <ul className="nav mobile-nav flex-column">
                <li><a className="nav-link" href="/privacy-policy">Privacy Policy</a></li>
                <li><a className="nav-link" href="/terms-of-service">Terms of Service</a></li>
                <li><a className="nav-link" href="#security">Security</a></li>
              </ul>
            </details>
          </div>
          <div className="d-block d-sm-none mb-3">
            <h6 className="mb-3">Find us on</h6>
            <div className="d-flex justify-content-between">
              <a
                href="https://www.linkedin.com/company/shoot-software"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex"
              >
                <span className="d-none">Linkedin</span>
                <LinkedinIcon width="24" height="24" />
              </a>
              {/* <a href="/" target="_blank" rel="noopener noreferrer" className="d-flex"> */}
              {/*  <span className="d-none">Twitter</span> */}
              {/*  <TwitterIcon width="24" height="24" /> */}
              {/* </a> */}
              <a
                href="https://www.facebook.com/trustshoot"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex"
              >
                <span className="d-none">Facebook</span>
                <FacebookIcon width="24" height="24" />
              </a>
              {/* <a href="/" target="_blank" rel="noopener noreferrer" className="d-flex"> */}
              {/*  <span className="d-none">Instagram</span> */}
              {/*  <InstagramIcon width="24" height="24" /> */}
              {/* </a> */}
            </div>
          </div>
        </div>
      </div>
      <p className="copyright mt-4">
        © 2024 Shoot Corporation. All rights reserved
      </p>
    </footer>
  );
}

export default Footer;
